<template>
  <div class="card">
    <div class="card-body text-center py-5">
      <font-awesome-icon
        icon="lock"
        size="2x"
        class="text-body-tertiary mb-3"
      />
      <h5>Compliance Groups is not enabled for this account</h5>
      <p class="text-body-tertiary mb-0">
        Ask Soldera support to enable the Compliance Groups demo.
      </p>
    </div>
  </div>
</template>
